// Project.js
import React from 'react';
import Education from './Education';

const Myeducation = () => {
  return (
    <div>
          <h1>Education</h1>
          <div href="#project" style={{ textDecoration: 'none' }}> <Education /></div>
    </div>
  );
};

export default Myeducation;
